import React, { useState } from 'react';
import md5 from 'md5';
import { withStyles } from '@material-ui/core/styles';
import AccountAircleIcon from '@material-ui/icons/AccountCircleRounded';

const styles = theme => ({
    root: {
        borderRadius: '50%',
        display: 'inline-block',
        overflow: 'hidden',
        position: 'relative',
    },
    defaultIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
    },
});

const BASE_URL = '//www.gravatar.com/avatar/';
const QUERY_URL = '?r=g&d=404&s=';

const INIT = 'init';
const ERROR = 'error';
const LOADED = 'loaded';

const Gravatar = ({ classes, email, color = '', size = 32 }) => {
    const [state, setState] = useState(INIT);
    const defaultIcon = (
        <AccountAircleIcon
            viewBox="2 2 20 20"
            style={{
                height: size,
                width: size,
                color: color,
            }}
            className={classes.defaultIcon}
        />
    );
    let gravatarIcon = '';
    if (email && state !== ERROR) {
        const hash = md5(email);
        const base = `${BASE_URL}${hash}${QUERY_URL}`;
        const src = `${base}${size}`;
        const src2x = `${base}${size * 2}`;
        gravatarIcon = (
            <img
                alt={`Gravatar for ${email}`}
                src={src}
                srcSet={`${src2x} 2x`}
                height={size}
                width={size}
                onLoad={() => setState(LOADED)}
                onError={() => setState(ERROR)}
            />
        );
    }
    return (
        <span
            className={classes.root}
            style={{
                height: size,
                width: size,
            }}
        >
            {state !== ERROR && gravatarIcon}
            {state !== LOADED && defaultIcon}
        </span>
    );
};

export default withStyles(styles)(Gravatar);
